var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cf-panel cf-panel-lg",
      staticStyle: {
        position: "relative",
        "min-height": "150px",
        display: "block",
      },
    },
    [
      _vm.loading ? _c("Spinner", { staticClass: "overlay" }) : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("table", { staticClass: "corpora public table" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _c("th", { staticClass: "table-icon" }),
              _vm._v(" "),
              _c("th", [_vm._v("Corpus")]),
              _vm._v(" "),
              _c("debug", [_c("th", [_vm._v("ID [debug]")])]),
              _vm._v(" "),
              _c("th", [_vm._v("Size")]),
              _vm._v(" "),
              _c("th", { staticClass: "table-icon" }),
              _vm._v(" "),
              _vm.isPrivate
                ? _c("th", { staticClass: "table-icon" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isPrivate
                ? _c("th", { staticClass: "table-icon" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isPrivate
                ? _c("th", { staticClass: "table-icon" })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.withExtraInfo, function (corpus) {
              return [
                _c(
                  "tr",
                  [
                    _c("td", [
                      _c("a", {
                        class: `icon fa fa-search ${
                          !corpus.canSearch ? "disabled" : ""
                        }`,
                        attrs: {
                          title: `Search the '${corpus.displayName}' corpus`,
                          href: corpus.canSearch ? corpus.searchUrl : undefined,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "corpus-name" }, [
                      _c(
                        "a",
                        {
                          class: `${!corpus.canSearch ? "disabled" : ""}`,
                          attrs: {
                            title: `Search the '${corpus.displayName}' corpus`,
                            href: corpus.canSearch
                              ? corpus.searchUrl
                              : undefined,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.corpusDisplayName(corpus)) +
                              " " +
                              _vm._s(corpus.statusText)
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("debug", [_c("td", [_vm._v(_vm._s(corpus.id))])]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(corpus.sizeString))]),
                    _vm._v(" "),
                    _vm.isPrivate
                      ? [
                          _c("td", [
                            _c("a", {
                              class: `icon fa fa-fw fa-cloud-upload ${
                                !corpus.canIndex ? "disabled" : ""
                              }`,
                              attrs: {
                                role: "button",
                                title: `Upload documents to the '${corpus.displayName}' corpus`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("upload", corpus.id)
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("a", {
                              staticClass: "icon fa fa-fw fa-user-plus",
                              attrs: {
                                role: "button",
                                title: `Share the '${corpus.displayName}' corpus`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("share", corpus.id)
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("a", {
                              class: `icon fa fa-fw fa-trash ${
                                !corpus.canIndex ? "disabled" : ""
                              }`,
                              attrs: {
                                role: "button",
                                title: `Delete the '${corpus.displayName}' corpus`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("delete", corpus.id)
                                },
                              },
                            }),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$set(
                                _vm.details,
                                corpus.id,
                                !_vm.details[corpus.id]
                              )
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "icon fa fa-fw fa-caret-down",
                            attrs: { title: "show details" },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.details[corpus.id]
                  ? _c("tr", [
                      _c("td", { attrs: { colspan: _vm.isPrivate ? 7 : 4 } }, [
                        _c("table", [
                          _c(
                            "tr",
                            { attrs: { title: corpus.timeModifiedFull } },
                            [
                              _c("th", [_vm._v("Last modified")]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(corpus.timeModified))]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isPrivate
                            ? _c("tr", [
                                _c("th", [_vm._v("Format")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      title:
                                        corpus.format && corpus.format.owner
                                          ? "Format owned by " +
                                            corpus.format.owner
                                          : "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        corpus.format && corpus.format.owner
                                          ? "*"
                                          : ""
                                      ) +
                                        _vm._s(
                                          corpus.format
                                            ? corpus.format.shortId
                                            : corpus.documentFormat
                                        )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Description")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(corpus.description || "No description")
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Documents")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(corpus.documentCount.toLocaleString())
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Tokens")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(corpus.tokenCount.toLocaleString())
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.isPrivate
        ? _c("div", [
            _vm.canCreateCorpus
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-lg",
                    attrs: { id: "create-corpus", type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("create")
                      },
                    },
                  },
                  [_vm._v("New corpus")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "text-danger",
                    staticStyle: { "padding-left": "8px" },
                  },
                  [_vm._m(0)]
                ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("em", [
      _vm._v("You have reached the private corpora limit."),
      _c("br"),
      _vm._v(
        "You will have to delete one of your corpora before you may create another."
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }